





















import { Component, Vue } from "vue-property-decorator";
import WelcomeDashboardComponent from "@/app/admin/components/dashboard/components/welcomeDashboard.component.vue";
import UsersInfoComponent from "@/app/admin/components/dashboard/components/usersInfo.component.vue";
import DauGraphicComponent from "@/app/admin/components/dashboard/components/dauGraphic.component.vue";
import WauGraphicComponent from "@/app/admin/components/dashboard/components/wauGraphic.component.vue";
import MauGraphicComponent from "@/app/admin/components/dashboard/components/mauGraphic.component.vue";
@Component({
  name: "dashboard-component",
  components: {
    MauGraphicComponent,
    WauGraphicComponent,
    DauGraphicComponent,
    UsersInfoComponent,
    WelcomeDashboardComponent,
  },
})
export default class DashboardComponent extends Vue {}
